import moment from "moment";
export const TABS = [
  { id: "milestone", label: "Billing Milestone" },
  { id: "timeline", label: "Timeline" },
  { id: "payments", label: "Payments" },
  { id: "preview", label: "Review" },
];

export const PAYMENT_STRUCTURE_OPTIONS = [
  { value: "ONE_TIME", label: "One-time Payment" },
  { value: "FIFTY_FIFTY", label: "50/50 Split" },
  { value: "CUSTOM", label: "Custom" },
];

export const strategyForStructure = (structure) => {
  if (structure === "ONE_TIME") return "ONE_TIME";
  if (structure === "FIFTY_FIFTY") return "SPLIT";
  return "CUSTOM";
};

export const structureForStrategy = (strategy) => {
  const s = String(strategy || "").toUpperCase();
  if (s === "SPLIT") return "FIFTY_FIFTY";
  if (s === "ONE_TIME") return "ONE_TIME";
  if (s === "CUSTOM") return "CUSTOM";
  return "ONE_TIME";
};

export const seedLinesForStructure = (structure, crPrice) => {
  const price = Number(crPrice || 0);
  if (structure === "ONE_TIME") {
    return [
      {
        id: null,
        displayName: "One-time Payment",
        amount: price ? String(price) : "",
        dueDate: "",
      },
    ];
  }
  if (structure === "FIFTY_FIFTY") {
    const half = price ? String(price / 2) : "";
    return [
      { id: null, displayName: "1st Payment", amount: half, dueDate: "" },
      { id: null, displayName: "2nd Payment", amount: half, dueDate: "" },
    ];
  }
  // CUSTOM
  return [];
};

export const PAYMENT_LINE_CURRENCY = "AED";
export const PAYMENT_LINE_TYPE = "CHANGE_REQUEST";
export const PAYMENT_LINE_STATUS = "PENDING";

export const DELIVERABLE_STATUS = {
  ADDED: "ADDED",
  MODIFIED: "MODIFIED",
  DELETED: "DELETED",
};

export const isoDay = (val) => {
  if (!val) return "";
  const s = String(val);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (s.includes("T")) return s.split("T")[0];
  return s;
};

export const formatDate = (val) =>
  val ? moment(val).format("MMM DD, YYYY") : "-";

export const milestoneLabelOf = (m) =>
  m?.description || m?.name || m?.groupName || m?.group_name || "-";

export const milestoneAmountOf = (m) =>
  Number(m?.amount ?? m?.milestone_amount ?? 0);

export const milestoneDueDateOf = (m) => m?.due_date || m?.dueDate || null;

export const milestoneGroupUuid = (m) =>
  m?.groupId || m?.group_id || m?.group_uuid || null;

export const isInitialDeposit = (m) => {
  if (!m) return false;
  if (m.isInitialDeposit) return true;
  if ((m.type || "").toUpperCase() === "PROJECT_INITIAL_DEPOSIT") return true;
  return (
    (m.description || m.name || m.groupName || m.group_name || "")
      .trim()
      .toLowerCase() === "initial deposit"
  );
};

export const parseDeliverables = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

let _localIdSeq = 0;
export const nextLocalId = () =>
  `local_${Date.now().toString(36)}_${++_localIdSeq}`;

export const AMOUNT_REGEX = /^-?\d{0,9}(\.\d{0,2})?$/;

export const formatAmountWithCommas = (raw) => {
  if (raw === "" || raw == null) return "";
  const s = String(raw);
  const [intPart, decPart] = s.split(".");
  const intWithCommas = (intPart || "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return intWithCommas + (decPart !== undefined ? "." + decPart : "");
};

export const toEditableDeliverables = (raw) =>
  parseDeliverables(raw).map((d) => ({
    id: d.id || nextLocalId(),
    deliverable_description: d.deliverable_description || d.name || "",
    start_date: d.start_date || "",
    end_date: d.end_date || "",
    // Same status convention as sub_activities — preserve explicit
    // ADDED/MODIFIED/DELETED from snapshots; leave null for fresh
    // server-loaded deliverables so the lifecycle handlers can
    // distinguish them from session-added ones.
    status: d.status || null,
    sub_activities: (d.sub_activities || []).map((s) => ({
      id: s.id || nextLocalId(),
      sub_activity_description:
        s.sub_activity_description || s.name || "",
      status: s.status || null,
    })),
  }));

export const deliverablesPayload = (dels) =>
  (dels || []).map((d) => ({
    deliverable_description: d.deliverable_description || "",
    start_date: d.start_date || null,
    end_date: d.end_date || null,
    status: d.status || "ADDED",
    sub_activities: (d.sub_activities || []).map((s) => ({
      sub_activity_description: s.sub_activity_description || "",
      status: s.status || "ADDED",
    })),
  }));

export const isMilestoneDirty = (milestone, edit) => {
  if (!milestone || !edit) return false;
  const baseAmount = String(milestoneAmountOf(milestone) ?? "");
  const baseDue = isoDay(milestoneDueDateOf(milestone));
  if (String(edit.amount ?? "") !== baseAmount) return true;
  if (isoDay(edit.dueDate) !== baseDue) return true;
  const a = JSON.stringify(deliverablesPayload(edit.deliverables));
  const b = JSON.stringify(
    deliverablesPayload(toEditableDeliverables(milestone.deliverables)),
  );
  return a !== b;
};
